import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/components/utils/utils";
import { useI18n } from "@/hooks/useI18n";

type PasswordInputProps = Omit<React.ComponentProps<typeof Input>, "type">;

/**
 * Campo password con il classico occhio per scoprire gli asterischi.
 * Il pulsante sta dentro il campo a destra, quindi il `pr-10` lascia spazio al testo.
 */
const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, disabled, ...props }, ref) => {
    const { t } = useI18n();
    const [visible, setVisible] = React.useState(false);
    const label = t(visible ? "common.hidePassword" : "common.showPassword");

    return (
      <div className="relative">
        <Input
          ref={ref}
          type={visible ? "text" : "password"}
          className={cn("pr-10", className)}
          disabled={disabled}
          {...props}
        />
        <button
          type="button"
          onClick={() => setVisible((v) => !v)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 disabled:opacity-50"
          disabled={disabled}
          aria-label={label}
          title={label}
        >
          {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
      </div>
    );
  }
);
PasswordInput.displayName = "PasswordInput";

export { PasswordInput };
